/**
 * @generated SignedSource<<d1969b3ebff9b5c07f5f0c499a232fbe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductExpireBatchDatePicker_StoreProduct$data = {
  readonly activeExpireBatches: ReadonlyArray<{
    readonly expireAtDate: {
      readonly isoString: string;
    };
    readonly id: string;
  }>;
  readonly " $fragmentType": "ProductExpireBatchDatePicker_StoreProduct";
};
export type ProductExpireBatchDatePicker_StoreProduct$key = {
  readonly " $data"?: ProductExpireBatchDatePicker_StoreProduct$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductExpireBatchDatePicker_StoreProduct">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductExpireBatchDatePicker_StoreProduct",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreProductExpireBatch",
      "kind": "LinkedField",
      "name": "activeExpireBatches",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "StoreZonedDate",
          "kind": "LinkedField",
          "name": "expireAtDate",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isoString",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "StoreProduct",
  "abstractKey": null
};

(node as any).hash = "a496717b1555cbdd5344047d767ab24e";

export default node;
